import { HttpClient, RequestOptions } from '@wix/http-client';
import { GetDelApi, GetDelType, PatchApi } from '../types/ApiTypes';

const httpClient = new HttpClient();

// DB API
async function getDelApi({ url, instance, method }: GetDelApi) {
  const opts: RequestOptions = {
    headers: { Authorization: instance },
  };
  try {
    const response = await httpClient[method](url, opts);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const dbGet = ({ url, instance }: GetDelType) => {
  return getDelApi({ url, instance, method: 'get' });
};

export const dbDel = ({ url, instance }: GetDelType) => {
  return getDelApi({ url, instance, method: 'delete' });
};

async function patchApi({ url, instance, method, body }: any) {
  const opts: RequestOptions = {
    headers: { Authorization: instance },
  };
  try {
    // @ts-expect-error
    const response = await httpClient[method](url, body, opts);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export const dbPatch = ({ url, instance, body, method }: PatchApi) => {
  return patchApi({ url, instance, body, method });
};
export const dbPut = ({ url, instance, body }: any) => {
  return patchApi({ url, instance, body, method: 'put' });
};
